import { useSnapshot } from 'valtio';
import { useStoreActions } from '../store/actions';
import { AppStore } from '../store/store';
import { FaChevronRight, FaChevronLeft } from "react-icons/fa6";
import { LazyLoadImage } from 'react-lazy-load-image-component';

import cls from '../styles/Block.module.scss';
import 'react-lazy-load-image-component/src/effects/blur.css';

const BlockM = () => {
  const {
    onHoverOverFloor,
    incrementSelectedFloor,
    decrementSelectedFloor,
    goPrevPage,
  } = useStoreActions();

  const { selectedFloor } = useSnapshot(AppStore);

  const onNextPage = (floor: number) => {
    AppStore.currentPage = 32;
    AppStore.selectedFloor = floor;
  };

  const onClickBack = () => {
    goPrevPage(10)
    AppStore.selectedFloor = 2
  };

  return (
    <div className={cls.mainContainer}>
      <div onClick={onClickBack} className={cls.mobileNavigationButton}>
        <img src="./images/arrow.png" alt="Назад" />
        <p>К выбору блока</p>
      </div>

      <div className={cls.infoContainer}>
        <div className={cls.selectionScreen}>
          <div className={cls.selectionBody}>
            <button onClick={decrementSelectedFloor} className={cls.arrowButton}>
              <FaChevronLeft />
            </button>
            <div className={cls.selectedBlock}>
              <p>Этаж</p>
              <p>{selectedFloor}</p>
            </div>
            <button onClick={() => incrementSelectedFloor(14)} className={cls.arrowButton}>
              <FaChevronRight />
            </button>
          </div>
        </div>

        <div className={cls.detailsContainer}>
          <div className={cls.detailItem}>
            <div className={cls.imageWrapper}>
              <LazyLoadImage
                src="./images/rooms/1.png"
                effect="blur"
              />
            </div>
            <div className={cls.textWrapper}>
              <p>1-комнатные</p>
              <p><span>Количество на этаже:</span> <span>8</span></p>
            </div>
          </div>
          <div className={cls.detailItem}>
            <div className={cls.imageWrapper}>
              <LazyLoadImage
                src="./images/rooms/2.png"
                effect="blur"
              />
            </div>
            <div className={cls.textWrapper}>
              <p>2-комнатные</p>
              <p><span>Количество на этаже:</span> <span>18</span></p>
            </div>
          </div>
          <div className={cls.detailItem}>
            <div className={cls.imageWrapper}>
              <LazyLoadImage
                src="./images/rooms/3.png"
                effect="blur"
              />
            </div>
            <div className={cls.textWrapper}>
              <p>3-комнатные</p>
              <p><span>Количество на этаже:</span> <span>6</span></p>
            </div>
          </div>
        </div>

        <button onClick={() => onNextPage(selectedFloor)} className={cls.selectButton}>
          Выбрать
        </button>
      </div>

      <div className={cls.imageContainer}>
        <div className={cls.imageBody}>
          <svg viewBox="0 0 1180 837.33331">
            <path
              onClick={() => onNextPage(2)}
              onMouseOver={() => onHoverOverFloor(2)}
              fill="#3292ffcc"
              className={cls.floor2}
              d="m 169.21107,730.61227 86.18694,-4.74423 13.442,0.79071 h 9.48848 l 132.83859,-3.16283 15.81412,-0.7907 238.00248,-7.11636 h 36.37248 l 77.48918,3.95353 v -37.16318 l -95.67542,-8.69776 h -17.39553 l -239.5839,14.2327 h -18.18623 l -142.32707,7.11636 -13.442,0.7907 -86.97765,6.32565 -1.58141,30.04683 z"
            />
            <circle className={`${cls.symbol2} ${cls.hidden}`} cx="800" cy="700" r="35" fill="#333333" />
            <text className={`${cls.symbol2} ${cls.hidden}`} x="800" y="695" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol2} ${cls.hidden}`} x="800" y="720" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">2</text>

            <path
              onClick={() => onNextPage(3)}
              onMouseOver={() => onHoverOverFloor(3)}
              fill="#3292ffcc"
              className={cls.floor3}
              d="m 166.04824,702.14686 88.55907,-5.53494 9.48847,-0.79071 163.67613,-7.11635 235.63036,-13.442 40.326,0.79071 75.11707,7.11635 -0.79071,-36.37247 -94.094,-12.6513 -275.95637,20.55836 -144.69919,9.48847 -9.48847,0.7907 -92.51259,8.69777 0.7907,27.67471 z"
            />
            <circle className={`${cls.symbol3} ${cls.hidden}`} cx="800" cy="660" r="35" fill="#333333" />
            <text className={`${cls.symbol3} ${cls.hidden}`} x="800" y="655" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol3} ${cls.hidden}`} x="800" y="680" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">3</text>

            <path
              onClick={() => onNextPage(4)}
              onMouseOver={() => onHoverOverFloor(4)}
              fill="#3292ffcc"
              className={cls.floor4}
              d="m 162.09471,674.47215 -0.7907,-19.76764 92.51259,-13.442 16.60483,-2 132.04789,-17.76765 h 25.30259 l 178.69953,-26.0933 46.65165,-5.53494 28.46542,-3.95353 23.72118,4.74424 71.95423,15.81411 v 37.95389 l -94.094,-9.48847 z"
            />
            <circle className={`${cls.symbol4} ${cls.hidden}`} cx="800" cy="630" r="35" fill="#333333" />
            <text className={`${cls.symbol4} ${cls.hidden}`} x="800" y="625" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol4} ${cls.hidden}`} x="800" y="650" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">4</text>

            <path
              onClick={() => onNextPage(5)}
              onMouseOver={() => onHoverOverFloor(5)}
              fill="#3292ffcc"
              className={cls.floor5}
              d="m 163.67613,654.70451 v -25.30259 l 90.93118,-18.18624 h 16.60482 l 138.37354,-24.51188 17.39553,-0.79071 188.18801,-32.41894 51.39588,-4.74424 14.23271,-3.16282 23.72118,6.32565 73.53565,21.34906 -1.58141,32.41894 -94.09401,-20.55836 -253.8166,36.37248 -24.51188,-0.79071 -136.00142,18.18624 -12.6513,2.37212 z"
            />
            <circle className={`${cls.symbol5} ${cls.hidden}`} cx="800" cy="590" r="35" fill="#333333" />
            <text className={`${cls.symbol5} ${cls.hidden}`} x="800" y="585" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol5} ${cls.hidden}`} x="800" y="610" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">5</text>

            <path
              onClick={() => onNextPage(6)}
              onMouseOver={() => onHoverOverFloor(6)}
              fill="#3292ffcc"
              className={cls.floor6}
              d="m 163.67613,630.19262 0.7907,-26.09329 89.34977,-21.34906 15.81412,-0.79071 139.95495,-29.25612 h 18.18624 l 185.81589,-41.90741 17.39553,1.58141 49.81447,-9.48847 98.04754,33.20965 -2.37212,35.58176 -94.88471,-27.6747 -253.0259,41.90741 -18.18623,0.79071 -143.90848,25.30259 -14.23271,-0.79071 z"
            />
            <circle className={`${cls.symbol6} ${cls.hidden}`} cx="800" cy="550" r="35" fill="#333333" />
            <text className={`${cls.symbol6} ${cls.hidden}`} x="800" y="545" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol6} ${cls.hidden}`} x="800" y="570" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">6</text>

            <path
              onClick={() => onNextPage(7)}
              onMouseOver={() => onHoverOverFloor(7)}
              fill="#3292ffcc"
              className={cls.floor7}
              d="m 165.25754,604.09933 v -26.884 l 88.55906,-23.72118 11.06988,1.58141 139.95495,-35.58177 20.55836,-0.7907 187.3973,-46.65165 18.18624,1.58141 48.23306,-12.6513 97.25683,37.16318 v 34.79106 l -94.88471,-30.83753 -51.39589,11.06989 -16.60482,-2.37212 -185.02519,41.11671 h -20.55835 l -136.00142,28.46541 -17.39553,2.37212 z"
            />
            <circle className={`${cls.symbol7} ${cls.hidden}`} cx="800" cy="510" r="35" fill="#333333" />
            <text className={`${cls.symbol7} ${cls.hidden}`} x="800" y="505" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol7} ${cls.hidden}`} x="800" y="530" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">7</text>

            <path
              onClick={() => onNextPage(8)}
              onMouseOver={() => onHoverOverFloor(8)}
              fill="#3292ffcc"
              className={cls.floor8}
              d="m 166.04824,576.42462 v -26.0933 l 87.76836,-26.09329 13.442,0.7907 139.16425,-37.95388 18.97694,-2.37212 188.18801,-52.18659 h 15.81412 l 52.18659,-13.442 96.46612,44.27953 -1.58141,34.00036 -95.67542,-37.95389 -47.44235,15.81412 -19.76765,-2.37212 -187.39731,46.65165 h -19.76764 l -139.95495,36.37248 -12.6513,-2.37212 z"
            />
            <circle className={`${cls.symbol8} ${cls.hidden}`} cx="800" cy="480" r="35" fill="#333333" />
            <text className={`${cls.symbol8} ${cls.hidden}`} x="800" y="475" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol8} ${cls.hidden}`} x="800" y="500" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">8</text>

            <path
              onClick={() => onNextPage(9)}
              onMouseOver={() => onHoverOverFloor(9)}
              fill="#3292ffcc"
              className={cls.floor9}
              d="m 166.04824,551.91274 88.55907,-26.88401 15.02341,1.58142 139.16424,-40.32601 19.76765,-0.7907 182.65307,-52.18659 22.93047,-0.79071 46.65165,-13.442 94.88471,41.90741 1.58141,-34.79106 -97.25682,-47.44235 -49.02377,7.90706 -18.18624,3.16282 -186.6066,60.09365 -15.81411,-3.16282 -136.00142,47.44235 -19.76765,-3.95353 -92.5126,26.0933 z"
            />
            <circle className={`${cls.symbol9} ${cls.hidden}`} cx="800" cy="440" r="35" fill="#333333" />
            <text className={`${cls.symbol9} ${cls.hidden}`} x="800" y="435" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol9} ${cls.hidden}`} x="800" y="460" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">9</text>

            <path
              onClick={() => onNextPage(10)}
              onMouseOver={() => onHoverOverFloor(10)}
              fill="#3292ffcc"
              className={cls.floor10}
              d="m 165.25754,517.12167 v -24.51188 l 84.60553,-24.93047 19.76765,-0.37212 138.37354,-50.60518 18.18623,-0.7907 183.44378,-65.6286 19.76765,2.37212 35.58176,-13.442 16.60483,-6.32565 96.46612,58.51224 -0.79071,34.79106 -98.04753,-47.44235 -48.23306,10.27918 -196.09507,59.30294 -24.51188,-0.79071 -131.25719,45.86095 -26.09329,-1.58141 z"
            />
            <circle className={`${cls.symbol10} ${cls.hidden}`} cx="800" cy="410" r="35" fill="#333333" />
            <text className={`${cls.symbol10} ${cls.hidden}`} x="800" y="405" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol10} ${cls.hidden}`} x="800" y="430" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">10</text>

            <path
              onClick={() => onNextPage(11)}
              onMouseOver={() => onHoverOverFloor(11)}
              fill="#3292ffcc"
              className={cls.floor11}
              d="m 166.04824,492.60979 v -29.72118 l 103.58248,-26.41894 50.60518,-17.39553 10.27918,-7.90706 96.46612,-30.83753 181.86236,-68.79142 56.14012,-13.442 17.39553,-7.90706 98.04754,61.67507 -2.37212,37.16318 -96.46612,-56.14013 -48.23306,21.34906 -23.72118,-4.74423 -181.07166,67.21 -22.13976,-0.7907 -134.42001,50.60518 -23.72118,1.58141 z"
            />
            <circle className={`${cls.symbol11} ${cls.hidden}`} cx="800" cy="370" r="35" fill="#333333" />
            <text className={`${cls.symbol11} ${cls.hidden}`} x="800" y="365" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol11} ${cls.hidden}`} x="800" y="390" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">11</text>

            <path
              onClick={() => onNextPage(12)}
              onMouseOver={() => onHoverOverFloor(12)}
              fill="#3292ffcc"
              className={cls.floor12}
              d="m 165.67613,461.77226 -2,-21.34906 83.81482,-28.46541 19.76765,-2.37212 62.46577,-22.13977 0.79071,-8.69776 71.95424,-26.0933 21.34906,-2.37212 57.72153,-23.72117 1.58141,1.58141 8.69777,-11.06988 124.14083,-48.23307 13.442,2.37212 49.81447,-20.55835 98.83824,61.67506 -0.79071,38.74459 -95.67541,-59.30294 -53.76801,16.60482 -11.86058,2.37212 -188.18801,70.37283 -94.09401,29.25612 -11.06988,8.69776 -68.00071,20.55835 z"
            />
            <circle className={`${cls.symbol12} ${cls.hidden}`} cx="800" cy="330" r="35" fill="#333333" />
            <text className={`${cls.symbol12} ${cls.hidden}`} x="800" y="325" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol12} ${cls.hidden}`} x="800" y="350" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">12</text>

            <path
              onClick={() => onNextPage(13)}
              onMouseOver={() => onHoverOverFloor(13)}
              fill="#3292ffcc"
              className={cls.floor13}
              d="m 166.04824,440.4232 -2.37211,-25.30259 87.76835,-30.83753 18.18624,-3.16282 43.48883,-18.18624 6.32564,-0.79071 -1.58141,-9.48847 92.5126,-37.95388 16.60482,2.37212 53.768,-25.30259 v -7.90706 l 132.8386,-56.14012 15.81412,3.95353 49.02376,-26.0933 102.00107,75.90777 -2.37212,28.46541 -94.88471,-60.88435 -52.9773,23.72117 -16.60482,-3.16282 -120.97801,45.86094 -8.69776,11.06989 -58.51224,23.72117 -17.39553,-0.7907 -77.48918,28.46541 v 7.11636 l -59.30295,22.93047 -23.72118,3.16282 z"
            />
            <circle className={`${cls.symbol13} ${cls.hidden}`} cx="800" cy="300" r="35" fill="#333333" />
            <text className={`${cls.symbol13} ${cls.hidden}`} x="800" y="295" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol13} ${cls.hidden}`} x="800" y="320" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">13</text>

            <path
              onClick={() => onNextPage(14)}
              onMouseOver={() => onHoverOverFloor(14)}
              fill="#3292ffcc"
              className={cls.floor14}
              d="m 163.67613,415.91132 -0.79071,-23.72118 12.6513,-4.74424 v -6.32564 l 77.48918,-33.20965 17.39553,1.16282 52.97729,-24.884 0.79071,-10.27918 86.18695,-40.326 18.18623,4.69777 52.18659,-25.25612 1.58141,-9.48848 30.04683,-15.02341 44.27953,-22.13976 58.51224,-26.0933 16.60482,7.11635 46.65165,-20.55835 99.62895,77.48918 1.58141,36.37247 -100.41965,-73.53565 -199.25789,75.11707 0.7907,8.69776 -51.39588,27.67471 -18.97694,-1.58141 -89.34977,33.20964 -1.58142,11.06989 -48.23306,18.18623 -17.39553,3.16283 z"
            />
            <circle className={`${cls.symbol14} ${cls.hidden}`} cx="800" cy="260" r="35" fill="#333333" />
            <text className={`${cls.symbol14} ${cls.hidden}`} x="800" y="255" fontFamily="Arial" fontSize="16" textAnchor="middle" fill="white">Этаж</text>
            <text className={`${cls.symbol14} ${cls.hidden}`} x="800" y="280" fontFamily="Arial" fontSize="24" textAnchor="middle" fill="white">14</text>
          </svg>

          <LazyLoadImage
            src="./images/blockM.png"
            alt="Структура"
            effect="blur"
            placeholderSrc='./images/placeholder/blockM.png'
          />

          <div onClick={onClickBack} className={cls.navigationButton}>
            <img src="./images/arrow.png" alt="Назад" />
            <p>К выбору блока</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlockM;
